(function() { window.GUID_b037674c_48ce_4a67_934a_05acaa5513c9 = { getGuid: function() { return "b037674c-48ce-4a67-934a-05acaa5513c9"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-opponents-v2",
                        callback: (accordion, e) => {
                            if (!WallSections.OpponentsSection.isWallLayout) {
                                return;
                            }
                            const { instance } = WallSections.OpponentsSection;
                            WallSections.OpponentsSection.appendFiltersCounterInTopBar();
                            WallSections.OpponentsSection.updateTeamRosterVisibility(accordion);
                            WallSections.OpponentsSection.setObservers(accordion);
                            const $chips = accordion.$Content.find(".chips");
                            if ($chips.length) {
                                $chips.css({
                                    top: `${Math.floor($("#section-top").outerHeight()) - 1}px`,
                                });
                                $chips.removeClass("hiddenforced");
                            }
                            //=================================================================================//
                            //============================// Event filter
                            //if (accordion.$Content.find("#BaseUrl").length) {
                            //    const extractQueryParam = (url: string, paramName: string): string => {
                            //        const queryParams = new URLSearchParams(url.split("?")[1]);
                            //        const eventIdParam = queryParams.get(paramName);
                            //        return eventIdParam;
                            //    };
                            //    const updateContent = (eventId: string) => {
                            //        try {
                            //            const _baseUrl = accordion.$Content.find("#BaseUrl").val();
                            //            let baseUrl = _baseUrl.replace(
                            //                "eventId=" + extractQueryParam(_baseUrl, "eventId"),
                            //                "eventId=" + eventId
                            //            );
                            //            baseUrl = baseUrl.replace(
                            //                "selectedEventId=" + extractQueryParam(baseUrl, "selectedEventId"),
                            //                "selectedEventId=" + eventId
                            //            );
                            //            const url = OpponentsSection.formatSectionUrl(baseUrl, accordion);
                            //            instance._filtersUIFreezed = true;
                            //            accordion.RefreshContent(() => {
                            //                instance._filtersUIFreezed = false;
                            //                OpponentsSection.updateUI(accordion);
                            //            }, url);
                            //        } catch (e) {
                            //            console.log(e);
                            //        }
                            //    };
                            //    DOM.$body.offon(
                            //        "click.eventDropdownCsrLeaderboard",
                            //        "#dropdown-event-drpdwn-csr-wall-events .list-item:not(.selected)",
                            //        (e) => {
                            //            const $listItem = $(e.currentTarget);
                            //            let eventId = extractQueryParam(
                            //                $listItem.attr("href"),
                            //                "EventId"
                            //            );
                            //            if (eventId == null) {
                            //                eventId = extractQueryParam(
                            //                    $listItem.attr("href"),
                            //                    "eventId"
                            //                );
                            //            }
                            //            updateContent(eventId);
                            //        }
                            //    );
                            //    Controls.DropDown.Events.ListItemClicked({
                            //        selector: CS.DOM.$body,
                            //        childSelector: "#dropdown-autocomplete-find-events-event-drpdwn-csr-wall-events",
                            //        callback: (list, e) => {
                            //            const extraValues = e.data.extraValues;
                            //            if (extraValues != null) {
                            //                const { Url } = extraValues;
                            //                const eventId = extractQueryParam(
                            //                    Url,
                            //                    "searchedEntityId"
                            //                );
                            //                updateContent(eventId);
                            //            }
                            //        }
                            //    });
                            //}
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=opponents-section.rendered.js.map
